"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(img) {
  return "https://cdn.privat24.ua/cardimage/".concat(img);
}